import styled from "styled-components";

import { COLORS, FONT_SIZE, FONTS } from "../../../../../constants/Styles";

const ButtonArea = styled.div`
  display: flex;
  gap: 1rem;
`;

const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ContainerSummaryContainer = styled.div`
  border-radius: 1rem;
  background-color: ${COLORS.tableBackground};
  padding: 1rem;
`;

const ProjectOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
  background-color: ${COLORS.badgeGray};
  padding: 2rem;
  border-radius: 1rem;
`;

const ItemWrapper = styled.div`
  flex: 1;
  min-width: 0;
`;
const ProjectOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  overflow: hidden;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`;

export {
  ButtonArea,
  MainContainer,
  Title,
  ContainerSummaryContainer,
  ProjectOptions,
  ProjectOptionContainer,
  ItemWrapper,
  ButtonRow,
};
